import { forwardRef, } from 'react';
import { Link as RouterLink, useMatch, } from 'react-router-dom';
import { Link, } from '@mui/material';

const CustomLink = forwardRef(({ children, to, sx = [], highlighting = true, ...props }, ref) => {
    const match = useMatch({
        path: to,
        end: to.length === 1,
    });

    return (
        <Link
            ref={ref}
            component={RouterLink}
            to={to}
            underline='none'
            sx={[
                ...(Array.isArray(sx) ? sx : [sx]),
                {
                    borderColor: (highlighting && !Array.isArray(sx) && Object.keys(sx).includes('border') && match && 'secondary.main') || 'borderColor.main',
                    color: (highlighting && match && 'secondary.main') || 'text.primary',
                    '& .MuiSvgIcon-root': {
                        color: (highlighting && match && 'secondary.main') || 'text.primary',
                    }
                },
            ]}
            {...props}>
            {children}
        </Link>
    )
});

export default CustomLink;
